module.exports = __webpack_public_path__ + "568325972c889f7458c97cbcd65c817f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tab-bg-gray.png
// module id = 547
// module chunks = 0